import Grid from "@mui/material/GridLegacy"

import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import useCartDispatch from "@components/_hooks/Cart/useCartDispatch";
import { isDefined, vatPricing, count, replaceStringWith, } from "@components/config/helpers";
import BootstrapButton from "@components/Custom/Buttons/BootstrapButton";

const ProductCardAddonGroups = ({ addon_groups }) => {
    const { VATFlag, tax } = useSelector((state) => state.globalReducer);
    const [checkIdx, setCheckIdx] = useState([])
    const [checkValue, setCheckValue] = useState([])

    const { SET_CART_ADDON_PRODUCT } = useCartDispatch();

    const removeSpacing = (str) => replaceStringWith(str, ' ', '');


    const handleSelector = (name, idx, index) => {
        const idxValue = typeof idx == 'number' ? idx : null;
        const checkIdxValue = typeof index == 'number' ? index : null;
        const newName = removeSpacing(name);
        setCheckValue((prevState) => ({
            ...prevState,
            [newName]: idxValue
        }))
        setCheckIdx((prevState) => ({
            ...prevState,
            [newName]: checkIdxValue
        }))
    }


    const addonHandler = (productId, slug, event, source, index) => {
        const item = { //update the items qty
            productId: productId,
            slug: slug,
            // event: event,
            source: source
        }

        SET_CART_ADDON_PRODUCT(index, item);
        return;

    }

    const isSelected = (name, index, idx, checkForNull = false) => {
        if (checkForNull && checkIdx?.[removeSpacing(name)] == null && checkValue?.[removeSpacing(name)] == null) return true;
        if (checkIdx?.[removeSpacing(name)] == index && checkValue?.[removeSpacing(name)] == idx) return true;
        return false;
    }

    return (
        <Grid container>
            {isDefined(addon_groups) && count(addon_groups) > 0 && (
                addon_groups.map((addon_group, index) => {
                    return (
                        <Grid item key={index} xs={12}>
                            <Typography className="w-100 p-1 default-grey" sx={{ fontSize: 14 }}>{addon_group.name}</Typography>
                            <BootstrapButton className="m-1" onClick={(event) => { addonHandler(null, null, null, null, index), handleSelector(addon_group.name, null, null) }}
                                variant={isSelected(addon_group.name, null, null, true) ? 'contained' : 'outlined'}
                            >
                                None
                            </BootstrapButton>
                            {isDefined(addon_group.products) && (
                                addon_group.products.map((addon_product, idx) => {
                                    return (
                                        <BootstrapButton className={`m-1`} onClick={(event) => { addonHandler(addon_product.product_id, addon_product.product_slug, event, null, index), handleSelector(addon_group.name, idx, index) }} key={idx} sx={{
                                            // backgroundColor: "palette.primary.main" not working this way?
                                        }}
                                            variant={isSelected(addon_group.name, index, idx) ? 'contained' : 'outlined'}

                                        >{addon_product.addon_product_name} <strong>{' +' + vatPricing(VATFlag, tax, addon_product.product_price)}</strong></BootstrapButton>
                                    )
                                })
                            )}
                        </Grid>
                    )
                })
            )}
        </Grid>
    )
}

export default ProductCardAddonGroups